import React from 'react';
import { useTranslate } from '@/translations';
import { useAppCustomers } from '@/hooks';
import {
  NoAccessAlert,
  PageContainer,
  Title,
  faEnvelope,
} from '@/ui/components';
import { Card } from 'antd';
import { EmailNotificationAccessDataGrid } from './components/EmailNotificationAccessDataGrid';

export const AdminEmailNotificationAccess: React.FC = () => {
  const { t } = useTranslate();
  const { hasSuperAdminAccess } = useAppCustomers();

  if (!hasSuperAdminAccess) {
    return <NoAccessAlert />;
  }

  return (
    <PageContainer>
      <Title title={t('emailNotificationAccess')} icon={faEnvelope} />
      <Card>
        <EmailNotificationAccessDataGrid />
      </Card>
    </PageContainer>
  );
};
